import { CandyThunkAction } from "../Core/Store/CandyReduxTypes";
import { FormSettingsActionType } from "../FormSettingsActions";

export function updatePortalUserId(): CandyThunkAction<Promise<void>> {
    return async (dispatch, __, form) => {
        const portalUser = await form.getPortalUser();

        dispatch({
            type: FormSettingsActionType.SetPortalUserId,
            payload: {
                value: portalUser.Id,
            },
        });
    };
}
